module.exports = __webpack_public_path__ + "img/da39a3ee5e6b4b0d3255bfef95601890afd80709_.bcdea946.jpg";